import { schema } from 'normalizr';

const sharepointFileSchema = new schema.Entity('sharepointFiles', {});

export default sharepointFileSchema;
